import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Storage } from '@ionic/storage';
import { AlertController, LoadingController, Platform, ToastController } from '@ionic/angular';
import { catchError, finalize, map, pairwise, shareReplay, tap } from 'rxjs/operators';
import { PayrollReceipt, PayslipYear } from '../modules/payslip/filter/filter.component';
import { Observable } from 'rxjs';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { PayrollReceipts } from '../models/PayrollReceipts';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';

@Injectable({
  providedIn: 'root'
})
export class PayrollAdvanceService {
  id: any;
  number: number = 0.00;
  comission: number = 0.00;
  commissions: any = [];
  date: any;
  banks: any;

  isLoading: boolean = false;

  accountSelected: any = null;
  paymentDate: any;

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache'
    })
  };

  constructor(
    private http: HttpClient,
    private storage: Storage,
    private file: File,
    private fileOpener: FileOpener,
    public loadingCtrl: LoadingController,
    public platform: Platform,
    private iab:InAppBrowser,
    private socialSharing : SocialSharing, 
    private alertController:AlertController,
    private toastCtrl: ToastController,
  ) {

  }


  getPaysLip(request: {
    sort: 'ASC' | 'DESC',
    from?: string,
    to?: string
  }): Observable<Array<PayslipYear>> {
    return this.http.post<{ data: Array<PayslipYear> }>(`${environment.API_URL}/payslip`, request)
      .pipe(
        map(({data}) => data),
      );
  }

  getReceipt(id: number): Observable<any> {
    return this.http.get<{ data: any }>(`${environment.API_URL}/payslip/${id}`).pipe(map(result => result.data));
  }
  // downloadReceipt=async (base64)=> {
  //   const writeDirectory = this.platform.is('ios') ? this.file.dataDirectory : this.file.externalDataDirectory;
  //   this.file.writeFile(writeDirectory, 'recibo.xml', base64, {replace: true})
  //     .then((value) => {
  //       if(this.platform.is('ios')){
  //       this.fileOpener.open(`${writeDirectory}recibo.xml`, 'text/xml')
  //         .then(() => console.log('File is opened'))      
  //         .catch(e => console.log('Error opening file', e));
  //       }else{
  //         this.socialSharing.share(null, null,`${writeDirectory}recibo.xml`, null).then((data) => {
  //           console.log('Shared via SharePicker'); 
  //          }).catch((err) =>  console.log('Was not shared via SharePicker'));
  //       }
  //     })
  //     .catch(() => {  
  //       console.error('Error writing xml file');
  //     });
    
  //      }

  downloadReceipt = async (base64: string, fiscal_folio: string) => {
    const writeDirectory = this.platform.is('ios') ? this.file.dataDirectory : this.file.externalDataDirectory;
    const fileName = `${fiscal_folio}.xml`;

    try {
      await this.file.writeFile(writeDirectory, fileName, base64, { replace: true });
      console.log(`✅ XML escrito: ${writeDirectory}${fileName}`);

      if (this.platform.is('ios')) {
        this.fileOpener.open(`${writeDirectory}${fileName}`, 'text/xml')
          .then(() => console.log('📂 File is opened'))
          .catch(e => console.error('❌ Error opening file', e));
      } else {
        this.socialSharing.share(
          null,
          null,
          `${writeDirectory}${fileName}`,
          null
        ).then(() => {
          console.log('✅ Shared via SharePicker');
        }).catch((err) => {
          console.error('❌ Was not shared via SharePicker', err);
        });
      }

    } catch (err) {
      console.error('❌ Error writing xml file', err);
    }
  }

    async presentAlertChooseType(data: any) {
      console.info("presentAlertChooseType: ", data);

      const buttons: any[] = [];

      // PDF solo si existe
      if (data.pdf_string) {
        buttons.push({
          text: 'PDF',
          handler: () => {
            this.readPayslip(data.id);
            this.base64toBlobPdfSave(data.pdf_string, `${data.fiscal_folio}-recibo.pdf`);
          },
        });
      }

      // XML solo si existe
      // if (data.xml_string) {
      //   buttons.push({
      //     text: 'XML',
      //     handler: async () => {
      //       this.readPayslip(data.id);
      //       let options;
      //       if (this.platform.is("ios")) {
      //         const browser = this.iab.create(environment.XML_BASE_URL + data.xml, '_blank', options);
      //         browser.on('loadstart').subscribe(() => {
      //           document.addEventListener('deviceready', () => {
      //             setTimeout(() => {
      //               this.downloadReceipt(data.xml_string);
      //             }, 1000);
      //           });
      //           browser.close();
      //         });
      //       } else {
      //         options = {
      //           hideurlbar: 'yes',
      //           location: 'yes',
      //           toolbarcolor: '#2196F3',
      //           toolbarposition: 'top',
      //           closebuttoncolor: '#ffffff',
      //           closebuttoncaption: 'Cerrar',
      //           presentationstyle: 'pagesheet',
      //           hidenavigationbuttons: 'yes',
      //         };
      //         const browser = this.iab.create(environment.XML_BASE_URL + data.xml, '_blank', options);
      //         browser.on('loadstop').subscribe(() => {
      //           browser.executeScript({ code: "document.body.style.backgroundColor = 'white';" });
      //         });
      //         browser.on('loadstart').subscribe(() => {
      //           document.addEventListener('deviceready', () => {
      //             setTimeout(() => {
      //               this.downloadReceipt(data.xml_string);
      //             }, 1000);
      //           });
      //         });
      //       }
      //     },
      //   });
      // }

      if (data.xml_string) {
        buttons.push({
          text: 'XML',
          handler: async () => {
            this.readPayslip(data.id);

            // Construir data URL a partir del base64
            const xmlBase64Url = data.xml_string.startsWith("data:")
              ? data.xml_string
              : `data:text/xml;base64,${data.xml_string}`;

            const fileName = `${data.fiscal_folio}.xml`;

            const options: InAppBrowserOptions = {
              hideurlbar: "yes",                 // "yes" | "no"
              location: "yes",                    // "yes" | "no"
              toolbarcolor: "#2196F3",            // string ok
              toolbarposition: "top",             // "top" | "bottom"
              closebuttoncolor: "#ffffff",        // string ok
              closebuttoncaption: "Cerrar",       // string ok
              presentationstyle: "pagesheet",     // "pagesheet" | "fullscreen" | "formsheet"
              hidenavigationbuttons: "yes"        // "yes" | "no"
            };
            // 1. Guardar el archivo localmente con downloadReceipt
            this.downloadReceipt(data.xml_string, data.fiscal_folio);

            // 2. Abrir en InAppBrowser directamente desde base64
            const browser = this.iab.create(xmlBase64Url, '_blank', options);

            browser.on('loadstop').subscribe(() => {
              console.log("✅ XML cargado en InAppBrowser desde base64");

              // Cambiar estilo del body (blanco) para que se vea mejor
              browser.executeScript({
                code: "document.body.style.backgroundColor = 'white';"
              });

              // Inyectar un botón de descarga visible en el navegador
              const injectScript = `
                (function() {
                  var btn = document.createElement('a');
                  btn.innerText = '⬇ Descargar XML';
                  btn.download = '${fileName}';
                  btn.href = '${xmlBase64Url}';
                  btn.style.display = 'block';
                  btn.style.padding = '12px';
                  btn.style.margin = '20px';
                  btn.style.background = '#2196F3';
                  btn.style.color = 'white';
                  btn.style.fontSize = '18px';
                  btn.style.textAlign = 'center';
                  btn.style.borderRadius = '8px';
                  btn.style.textDecoration = 'none';
                  document.body.insertBefore(btn, document.body.firstChild);
                })();
              `;
              browser.executeScript({ code: injectScript });
            });

            browser.on('loaderror').subscribe((err) => {
              console.error("❌ Error cargando XML en IAB", err);
            });
          },
        });
      }

      // Constancia Firma Digital solo si existe
      if (data.nom151_string) {
        buttons.push({
          text: 'Constancia Firma Digital',
          handler: () => {
            this.readPayslip(data.id);
            this.base64toBlobPdfSave(data.nom151_string, `${data.fiscal_folio}-constancia.pdf`);
          },
        });
      }

      if (buttons.length === 0) {
        console.warn('No hay archivos disponibles para mostrar.');
        this.presentErrorToast('No hay archivos disponibles para mostrar.');
        return;
      }

      const alert = await this.alertController.create({
        cssClass: 'my-custom-class',
        header: 'Confirmar!',
        message: 'Seleccione el tipo de archivo que desea ver:',
        buttons,
      });

      await alert.present();
    }

    base64toBlobPdfSave(data: any, name: any) {
      console.log('base64toBlobSave:', name);
      console.log('base64toBlobSave:', data);
      const writeDirectory = this.platform.is('ios') ? this.file.dataDirectory : this.file.externalDataDirectory;
      console.log('base64toBlobSave ====> writeDirectory', writeDirectory);
      this.file.writeFile(writeDirectory, `${name}.pdf`, this.convertBase64ToBlob(data, 'data:application/pdf;base64'), {replace: true})
        .then((value) => {
          console.log('==> VALUIE', value);
          this.fileOpener.open(`${writeDirectory}${name}.pdf`, 'application/pdf')
            .then(() => console.log('File is opened'))
            .catch(e => console.log('Error opening file', e));
        })
        .catch(() => {
          console.error('Error writing pdf file');
        });
    }

    async presentErrorToast(msg) {
      const toast = await this.toastCtrl.create({
        message: msg,
        duration: 3000,
        position: "top",
        color: "danger",
        cssClass: "toast",
      });
      toast.present();
    }

 itemSelected(item: any) {
    this.readPayslip(item.id);

    // const writeDirectory = this.file.externalApplicationStorageDirectory;
    const writeDirectory = this.platform.is('ios') ? this.file.dataDirectory : this.file.externalDataDirectory;

    // this.file.checkDir(this.file.dataDirectory, '')
    //   .then(_ => console.log('Directory exists'))
    //   .catch(err => console.log('Directory doesn\'t exist'));


    console.log('====> writeDirectory', writeDirectory);

    this.file.writeFile(writeDirectory, 'recibo.pdf', this.convertBase64ToBlob(item.pdf_string_sign, 'data:application/pdf;base64'), {replace: true})
      // console.log('===> RESULT, ', result);
      .then((value) => {
        console.log('==> VALUIE', value);
        this.fileOpener.open(`${writeDirectory}recibo.pdf`, 'application/pdf')
          .then(() => console.log('File is opened'))
          .catch(e => console.log('Error opening file', e));


        // this.opener.open(writeDirectory + filename, 'application/pdf')
        //   .catch(() => {
        //     console.log('Error opening pdf file');
        //   });
      })
      .catch(() => {
        console.error('Error writing pdf file');
      });

    // this.fileOpener.showOpenWithDialog(item.pdf_string, 'application/pdf')
    //   .then(() => console.log('File is opened'))
    //   .catch(e => console.log('Error opening file', e));
  }
  createPdf(base64:any,name:string) {
    console.log('===>ITEM:',name);
    const writeDirectory = this.platform.is('ios') ? this.file.dataDirectory : this.file.externalDataDirectory;
    this.file.writeFile(writeDirectory, name, this.convertBase64ToBlob(base64, 'data:application/pdf;base64'), {replace: true})
      .then((value) => {
        console.log('==> VALUIE', value);
        this.fileOpener.open(`${writeDirectory}${name}`, 'application/pdf')
          .then(() => console.log('File is opened'))
          .catch(e => console.log('Error opening file', JSON.stringify(e)));
      })
      .catch(() => {
        console.error('Error writing pdf file');
      });
  }
  convertBase64ToBlob(b64Data, contentType): Blob {
    contentType = contentType || '';
    const sliceSize = 512;
    b64Data = b64Data.replace(/^[^,]+,/, '');
    b64Data = b64Data.replace(/\s/g, '');
    const byteCharacters = window.atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: contentType});
  }


  readPayslip(receiptId: number): void {
    this.http.get(`${environment.API_URL}/payslip/edit/${receiptId}`)
      .pipe(
        catchError((err) => {
          console.log('Ocurrio un error');
          return err;
        })).subscribe(_ => {
      console.log('Operación exitosa');
    });
  }

  //Obtener payroll_advanceds data
  getData() {
    return this.http.get(environment.API_URL + '/payroll_advanceds/get_data');
  }

  //mandar payroll_advanceds data
  postData(data: any) {
    // Presentamos el Loading al inicio de la llamada
    this.presentLoading();
    return this.http.post(environment.API_URL + '/payroll_advanceds/create', data, this.httpOptions)
      .pipe(
        tap(response => {
          return response;
        }),
        shareReplay(1),
        finalize(() => this.dismissLoading())
      );
  }

  postNewAccountData(data: any) {
    return this.http.post(environment.API_URL + '/payroll_advanceds/create_bank', data, this.httpOptions);
  }

  dropAccount(account_id) {
    return this.http.get(environment.API_URL + '/payroll_advanceds/drop_bank/' + account_id);
  }

  // Creación del loading
  async presentLoading() {
    this.isLoading = true;
    return await this.loadingCtrl.create({
      message: 'Estamos procesando tu transacción por favor espera un momento.'
    }).then((a) => {
      a.present().then(() => {
        if (!this.isLoading) {
          a.dismiss();
        }
      });
    });
  }

  // Cierre del loading
  async dismissLoading() {
    this.isLoading = false;
    return await this.loadingCtrl.dismiss();
  }
  SingedPayslip(receipt: PayrollReceipts | any) {
    if (receipt.checkbox == 'activo'){
      this.id = receipt.high_employee_id;
      console.log(this.id);
    }else{
       this.id = receipt.id;
       console.log(this.id);

    }
    return this.http.put(`${environment.API_URL}/payslip/signed/${this.id}`,receipt);
}
 

  }
  
